export default function Billing() {
  return (
    <div className="mx-auto max-w-5xl p-6">
      <h1 className="text-2xl font-bold">Facturation</h1>
      <p className="mt-2 text-text">DawaRedacc fonctionne avec un système de crédits.</p>
      <div className="mt-4 grid gap-4 md:grid-cols-2">
        <div className="rounded border p-4">
          <h2 className="font-semibold">Crédits</h2>
          <ul className="mt-1 list-disc pl-4 text-sm text-muted space-y-1">
            <li>1 étape de génération = 1 crédit.</li>
            <li>Crédits non consommés si l’étape est déjà générée.</li>
            <li>Remboursement automatique en cas d’échec technique.</li>
          </ul>
        </div>
        <div className="rounded border p-4">
          <h2 className="font-semibold">Achat & factures</h2>
          <p className="mt-1 text-sm text-muted">
            Achetez des crédits depuis la page <a href="/credits" className="underline">Crédits</a>.
            Les factures sont disponibles sur demande (bientôt en libre‑service).
          </p>
        </div>
      </div>
    </div>
  );
}
